import HouseOwnerPricesCard from './house-owner-prices-card'

export { HouseOwnerPricesCard }
